import differenceInHours from 'date-fns/difference_in_hours';

export default function(
  dateLeft: Date | string | number,
  dateRight: Date | string | number
): number {
  return differenceInHours(dateLeft, dateRight);
}
